import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

interface Slide {
  id: string;
  categoryId: string;
  name: string;
  tag: string;
  desc: string;
  image: string;
}

const slides: Slide[] = [
  {
    id: 'xingguang',
    categoryId: 'windows-player',
    name: '星光影音',
    tag: 'Windows · 高清播放器',
    desc: '老牌 Windows 高清播放器，本地 4K 片源与在线影视通吃，硬件解码效率高，启动迅速、稳定不掉帧。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20abstract%20banner%20of%20a%20dark%20movie%20theater%20with%20a%20glowing%20amber%20projector%20beam%20and%20floating%20film%20reels%2C%20deep%20blue%20ambient%20lighting%2C%20premium%20tech%20mood%2C%20wide%20composition%2C%20no%20text&width=1600&height=640&seq=hero-xingguang&orientation=landscape',
  },
  {
    id: 'yunque',
    categoryId: 'mac-player',
    name: '云雀播放器',
    tag: 'Mac · 原生体验',
    desc: 'macOS 上口碑极佳的原生播放器，界面精致、渲染细腻，完美适配 Retina 屏幕与触控板手势。',
    image: 'https://readdy.ai/api/search-image?query=Minimal%20cinematic%20banner%20of%20a%20sleek%20aluminium%20laptop%20on%20a%20dark%20desk%20glowing%20with%20amber%20screen%20light%2C%20deep%20blue%20studio%20backdrop%2C%20premium%20apple%20aesthetic%2C%20wide%20composition%2C%20no%20text&width=1600&height=640&seq=hero-yunque&orientation=landscape',
  },
  {
    id: 'leiting',
    categoryId: 'android-player',
    name: '雷霆播放器',
    tag: 'Android · 随身观影',
    desc: '安卓端热门播放器，手势操作顺滑，支持投屏、倍速与悬浮小窗，随时随地畅快看片。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20abstract%20banner%20with%20a%20smartphone%20casting%20a%20glowing%20video%20beam%20into%20dark%20space%2C%20deep%20blue%20gradient%20background%20with%20amber%20light%20trails%2C%20premium%20tech%20mood%2C%20wide%20composition%2C%20no%20text&width=1600&height=640&seq=hero-leiting&orientation=landscape',
  },
  {
    id: 'lingxi',
    categoryId: 'tools',
    name: '灵犀解码库',
    tag: '全平台 · 解码扩展',
    desc: '覆盖全平台的开源解码库，一次安装让系统与播放器支持几乎所有音视频格式，永久免费无捆绑。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20abstract%20banner%20of%20glowing%20interconnected%20data%20nodes%20and%20circuit%20lines%20in%20deep%20blue%20and%20amber%2C%20futuristic%20technology%20network%20concept%2C%20wide%20composition%2C%20no%20text&width=1600&height=640&seq=hero-lingxi&orientation=landscape',
  },
];

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 5500);
    return () => window.clearInterval(timer);
  }, []);

  const go = (dir: number) => {
    setIndex((prev) => (prev + dir + slides.length) % slides.length);
  };

  const current = slides[index];

  return (
    <section className="w-full">
      <div className="relative h-[420px] w-full overflow-hidden md:h-[520px]">
        {slides.map((slide, i) => (
          <div
            key={slide.id}
            className={`absolute inset-0 transition-opacity duration-700 ${
              i === index ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <img
              src={slide.image}
              alt={`${slide.name} 影视播放软件推荐`}
              title={`${slide.name} - 看片软件推荐`}
              className="h-full w-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-primary-950/90 via-primary-950/70 to-primary-950/30"></div>
          </div>
        ))}

        <div className="relative mx-auto flex h-full max-w-[1280px] flex-col justify-center px-4 md:px-6">
          <div key={current.id} className="kp-fade-up max-w-2xl">
            <span className="mb-4 inline-flex items-center gap-2 rounded-md bg-accent-500 px-3 py-1.5 text-xs font-semibold text-foreground-950">
              <i className="ri-fire-fill"></i>
              {current.tag}
            </span>
            <h2 className="mb-3 text-3xl font-extrabold text-white md:text-5xl">{current.name}</h2>
            <p className="mb-7 max-w-xl text-sm leading-relaxed text-background-100 md:text-base">
              {current.desc}
            </p>
            <div className="flex flex-wrap items-center gap-3">
              <Link
                to={`/detail/${current.id}`}
                className="flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-semibold text-foreground-950 transition-colors hover:bg-accent-600"
              >
                <i className="ri-download-line text-base"></i>
                立即查看下载
              </Link>
              <Link
                to={`/category/${current.categoryId}`}
                className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-100/50 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
              >
                <i className="ri-apps-2-line text-base"></i>
                进入分类
              </Link>
            </div>
          </div>
        </div>

        <button
          type="button"
          onClick={() => go(-1)}
          aria-label="上一张"
          className="absolute left-3 top-1/2 flex h-10 w-10 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full bg-background-50/20 text-white backdrop-blur transition-colors hover:bg-background-50/40 md:left-6"
        >
          <i className="ri-arrow-left-s-line text-2xl"></i>
        </button>
        <button
          type="button"
          onClick={() => go(1)}
          aria-label="下一张"
          className="absolute right-3 top-1/2 flex h-10 w-10 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full bg-background-50/20 text-white backdrop-blur transition-colors hover:bg-background-50/40 md:right-6"
        >
          <i className="ri-arrow-right-s-line text-2xl"></i>
        </button>

        <div className="absolute bottom-6 left-1/2 flex -translate-x-1/2 items-center gap-2">
          {slides.map((slide, i) => (
            <button
              key={slide.id}
              type="button"
              aria-label={`切换到第${i + 1}张`}
              onClick={() => setIndex(i)}
              className={`h-2 cursor-pointer rounded-full transition-all ${
                i === index ? 'w-8 bg-accent-500' : 'w-2 bg-background-50/50'
              }`}
            ></button>
          ))}
        </div>
      </div>
    </section>
  );
}